import {
    dismissModal,
    getModalContext,
    getOpenModal,
    ModalContext,
    openLoginModal,
    openSetPasswordModal,
} from '@/redux/modules/modal';
import { getCreateAccountState, submitCreateAccount } from '@/redux/modules/createAccount';
import { getTriggerId, isTracking, openLoginModalFromChecker } from '@/redux/modules/shouldLogin';
import { isUiMobile, isUiTablet } from '@/redux/modules/browser';
import React, { Component } from 'react';
import AuctionContextSignUpModal from './AuctionContextSignUpModal';
import AuctioneerContextSignUpModal from './AuctioneerContextSignUpModal';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import FollowSearchContextSignUpModal from './FollowSearchContextSignUpModal';
import { getAttributionData } from '@/redux/modules/analytics';
import { getBidderExists } from '@/redux/modules/bidderExists';
import { getIsWhiteLabel } from '@/redux/modules/whiteLabel';
import isEqual from 'react-fast-compare';
import ItemContextSignUpModal from './ItemContextSignUpModal';
import { modalTypes } from '@/enums';
import SignUpModal from './SignUpModal';

const mapStateToProps = (state) => {
    const attributionData = getAttributionData(state);
    const bidderExists = getBidderExists(state);
    const { error, submitted, success } = getCreateAccountState(state);
    const isMobile = Boolean(isUiMobile(state));
    const isTablet = isUiTablet(state);
    const openModal = getOpenModal(state);
    const whiteLabel = getIsWhiteLabel(state);
    const tracking = isTracking(state);
    const triggerId = getTriggerId(state);
    const modalContext = getModalContext(state);

    return {
        attributionData,
        bidderExists,
        error,
        isMobile,
        isTablet,
        modalContext,
        openModal,
        submitted,
        success,
        tracking,
        triggerId,
        whiteLabel,
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            dismissModal,
            openLoginModal,
            openLoginModalFromChecker,
            openSetPasswordModal,
            submitCreateAccount,
        },
        dispatch
    );

type Props = {
    attributionData: any;
    bidderExists: boolean;
    dismissModal: Function;
    error: string;
    isMobile: boolean;
    isTablet: boolean;
    modalContext: ModalContext;
    openLoginModal: Function;
    openLoginModalFromChecker: Function;
    openModal: string;
    openSetPasswordModal: Function;
    submitCreateAccount: Function;
    submitted: boolean;
    success: boolean;
    tracking: boolean;
    triggerId: string;
    whiteLabel: boolean;
};

type State = {
    email: string;
};

class SignUpModalContainer extends Component<Props, State> {
    state = {
        email: '',
    };

    shouldComponentUpdate = (nextProps, nextState) =>
        !isEqual(this.props, nextProps) || !isEqual(this.state, nextState);

    setEmail = (email) => {
        this.setState({ email });
    };

    submitCreateAccount = (email, agree) => {
        this.props.submitCreateAccount(email, agree, this.props.attributionData);
    };

    cancelSignUp = () => {
        this.props.dismissModal();
    };

    openLoginModal = () => {
        if (this.props.tracking) {
            this.props.openLoginModalFromChecker(this.props.triggerId);
        } else {
            this.props.openLoginModal();
        }
    };

    render() {
        const show = this.props.openModal === modalTypes.SIGN_UP;
        const { bidderExists, error, isMobile, isTablet, modalContext, submitted, whiteLabel } = this.props;
        const showItemContextModal = [
            'see sold price',
            'save item',
            'place bid',
            'ask a question - item',
            'register for auction - item',
        ].includes(modalContext.type);
        const showAuctioneerContextModal = ['follow auctioneer', 'ask a question - auctioneer'].includes(
            modalContext.type
        );
        const showAuctionContextModal = modalContext.type === 'register for auction';
        const showFollowSearchContextModal = modalContext.type === 'follow search';

        let modal;

        if (modalContext.type === 'default') {
            modal = (
                <SignUpModal
                    bidderExists={bidderExists}
                    cancelSignUp={this.cancelSignUp}
                    error={error}
                    isMobile={isMobile}
                    isTablet={isTablet}
                    openLoginModal={this.openLoginModal}
                    setEmail={this.setEmail}
                    show={show}
                    submitCreateAccount={this.submitCreateAccount}
                    submitted={submitted}
                    whiteLabel={whiteLabel}
                />
            );
        } else if (showItemContextModal) {
            modal = (
                <ItemContextSignUpModal
                    bidderExists={bidderExists}
                    cancelSignUp={this.cancelSignUp}
                    error={error}
                    openLoginModal={this.openLoginModal}
                    setEmail={this.setEmail}
                    show={show}
                    submitCreateAccount={this.submitCreateAccount}
                    submitted={submitted}
                    whiteLabel={whiteLabel}
                />
            );
        } else if (showAuctioneerContextModal) {
            modal = (
                <AuctioneerContextSignUpModal
                    bidderExists={bidderExists}
                    cancelSignUp={this.cancelSignUp}
                    error={error}
                    openLoginModal={this.openLoginModal}
                    setEmail={this.setEmail}
                    show={show}
                    submitCreateAccount={this.submitCreateAccount}
                    submitted={submitted}
                    whiteLabel={whiteLabel}
                />
            );
        } else if (showAuctionContextModal) {
            modal = (
                <AuctionContextSignUpModal
                    bidderExists={bidderExists}
                    cancelSignUp={this.cancelSignUp}
                    error={error}
                    openLoginModal={this.openLoginModal}
                    setEmail={this.setEmail}
                    show={show}
                    submitCreateAccount={this.submitCreateAccount}
                    submitted={submitted}
                    whiteLabel={whiteLabel}
                />
            );
        } else if (showFollowSearchContextModal) {
            modal = (
                <FollowSearchContextSignUpModal
                    bidderExists={bidderExists}
                    cancelSignUp={this.cancelSignUp}
                    error={error}
                    openLoginModal={this.openLoginModal}
                    setEmail={this.setEmail}
                    show={show}
                    submitCreateAccount={this.submitCreateAccount}
                    submitted={submitted}
                    whiteLabel={whiteLabel}
                />
            );
        }

        return modal;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SignUpModalContainer);
